// Codes the API attaches to 409 responses whose message is written for an
// admin to act on. Any other server text stays hidden: it can carry database
// internals such as constraint names.
const ADMIN_FACING_ERROR_CODES: readonly string[] = [
  'region_merge_blocked',
  'region_delete_blocked',
  'region_update_blocked',
  'region_create_blocked',
  'region_set_save_blocked',
  'region_set_delete_blocked',
]

type ApiErrorShape = {
  response?: { status?: number; data?: { detail?: unknown } }
}

// Duck-typed rather than axios.isAxiosError: refine passes the rejected error
// through untouched, and tests mock axios wholesale.
export function adminFacingMessage(error: unknown): string | null {
  const response = (error as ApiErrorShape | null | undefined)?.response
  if (response?.status !== 409) return null

  const detail = response.data?.detail
  if (!detail || typeof detail !== 'object') return null

  const { code, message } = detail as { code?: unknown; message?: unknown }
  if (typeof code !== 'string' || !ADMIN_FACING_ERROR_CODES.includes(code)) {
    return null
  }
  return typeof message === 'string' ? message : null
}

export function locationDeleteErrorNotification(error: unknown) {
  return {
    type: 'error' as const,
    message: 'Could not delete location',
    description:
      adminFacingMessage(error) ?? 'Error deleting location. Please try again.',
  }
}
